import PortfolioConstraintsStep from './PortfolioConstraintsStep.tsx';
import type { StepConfig } from '../../../../technical/wizard/StepConfig.ts';
import type { PortfolioLevelConstraintsStepInput } from './PortfolioConstraintsStep.validation.ts';
import type { SelectOption } from '../../../../technical/inputs/Select/Select.props.ts';
import type { ISecondaryConstrainedQuantity } from '../../../../../generated/graphql.tsx';
import type { NotVerifiedAssetWithId } from 'components/market/asset/AssetService.tsx';

export const config = ({
  benchmarks,
  secondaryConstraintQuantityValues,
  goToNextStep,
}: {
  benchmarks: NotVerifiedAssetWithId[];
  secondaryConstraintQuantityValues: SelectOption<ISecondaryConstrainedQuantity>[];
  goToNextStep: () => void;
}): StepConfig<PortfolioLevelConstraintsStepInput> => ({
  label: 'Portfolio level constraints',
  element: (
    <PortfolioConstraintsStep
      goToNextStep={goToNextStep}
      benchmarks={benchmarks}
      secondaryConstraintOptions={secondaryConstraintQuantityValues}
    />
  ),
  fields: ['portfolioConstraints'],
});
